import Layer from '../Rendering/Layer';
import Fps from '../Models/Fps';
import InputEventHandler from './InputEventHandler';
import RoomPositioner from './RoomPositioner';
import MiniViewport from '../Models/MiniViewport';
import Search from '../Models/Search';
import HoverNameList from '../Models/HoverNameList'
import PathGenerator from './PathGenerator'
import ShortestPathGenerator from './ShortestPathGenerator'
import gsap from 'gsap';
import MotionPathPlugin from 'gsap/MotionPathPlugin';
import TopBar from '../Models/TopBar'
import NameSeeder from '../Seeders/NameSeeder'
import ToolTipText from '../Models/ToolTipText'
import HoverMaskContainer from '../Models/HoverMaskContainer'
import RoomUpdater from '../Api/RoomUpdater'
import PersonUpdater from '../Api/PersonUpdater'
import Wall from '../Models/Wall'

gsap.registerPlugin(MotionPathPlugin);

import version from 'raw-loader!../../../version.txt';
import colorSchemeRepository from '../Images/ColorSchemeRepository'
import game from "./GameInstance";
import UrlExecutor from "../Api/UrlExecutor";
import HoverMask from "../Models/HoverMask";
// console.log(version);

let hoverMaskContainer = HoverMaskContainer.instance();
let throttle = false;

export default class Game {


  constructor() {

    if (typeof window.loadedFonts === 'undefined') {
      window.loadedFonts = [];
    }

    window.loadedFonts.push = (n) => {

      window.loadedFonts[window.loadedFonts.length] = n;

      setTimeout(() => {
        Object.keys(this.layers).forEach(layer => {


          this.layers[layer].forceRedraw();


        });
      }, 500);

    };

    this.debug = true;
    this.paused = true;
    this.title = 'Map';
    this.mode = 'map';
    this.searchUrl = '';

    this.onlyAttendeeTitle = 'Attendee';
    this.mulitpleAttendeesTitle = 'Attendees';

    this.roomPositioner = new RoomPositioner(this);
    this.pathGenerator = new PathGenerator(this);
    this.shortestPathGenerator = new ShortestPathGenerator(this);

    this.apiBase = 'http://lobby.lgd.demo.blixx.nl/api/';

    this.roomUpdater = new RoomUpdater(this.apiBase);
    this.personUpdater = new PersonUpdater(this.apiBase);

    this.colorScheme = colorSchemeRepository;

    // this.setup();

  }

  setup() {


    this.focus = true;

    this.apiMode = true;


    this.rooms = [];
    this.people = [];

    this.points = [];
    this.paths = [];

    this.width = 10;
    this.height = 10;

    this.wall = null;

    this.frame = 0;

    this.entrancePoint = null;

    this.x = 0;
    this.y = 0;
    this.dx = 0;
    this.dy = 0;

    this.nativeScale =  1;
    this.scale = this.nativeScale;

    this.miniviewport = null;

    this.layers = null;


    this.view = 'people';
    this.peopleCount = 0;

    this.eventHandler = new InputEventHandler(this);

    this.hoverMask = null;
  }

  setDebug(state){
    this.debug = state;
  }

  debugEnabled(){
    return this.debug;
  }

  getVersion() {
    return version.replace(/^\s+|\s+$/g, '');
  }

  switchApiMode() {
    this.apiMode = !this.apiMode;
    if (this.debugEnabled()) {
      this.fps.needsRendering = true;
    }
  }

  isRetinaDisplay() {

    if (window.matchMedia) {
      var mq = window.matchMedia("only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)");
      return (mq && mq.matches || (window.devicePixelRatio > 1));
    }

  }

  updatePersonIndicator(direction) {
    this.peopleCount += direction;
    if (this.debugEnabled()) {
      this.fps.needsRendering = true;
    }
  }

  setScale(scale) {

    this.scale = scale;

    let width = this.getWindowSize().width;
    let height = this.getWindowSize().height;

    Object.keys(this.layers).forEach(layer => {

      this.layers[layer].setScale(scale, width, height);

    });

  }

  switchView() {

    this.view = this.view === 'people' ? 'speakers' : 'people';

    this.topBar.changeStatus(this.view === 'people');
    this.topBar.needsRendering = true;

    this.layers.ground.forceRedraw();

    if (this.view === 'people') {
      this.rooms.forEach((room) => {

        room.positionPeople();
        room.personIndicator.show();

      });
    }

  }

  stop() {

    if (this.paused) {
      return;
    }

    this.eventHandler.destructor()
    this.paused = true;
    this.roomUpdater.pause();
    this.personUpdater.pause();

    Object.keys(this.layers).forEach(key => {
      this.layers[key].garbageCollect();
    });

    this.layers = {};

    this.rooms.splice();
    this.people.splice();
    this.points.splice();
    this.paths.splice();
    if (this.wall) {
      this.wall.garbageCollect();
    }
    this.wall = null;

    this.fps = null;
    this.miniviewport = null;
    this.search = null;

    if (this.shortestPathGenerator) {
      this.shortestPathGenerator.garbageCollect();
    }
    if (this.pathGenerator) {
      this.pathGenerator.garbageCollect();
    }
    if (this.personUpdater) {
      this.personUpdater.garbageCollect();
    }
    if (hoverMaskContainer) {
      hoverMaskContainer.garbageCollect();
    }


  }

  start(roomEndpoint, personEndpoint) {

    if (!this.paused) {
      return;
    }

    this.setup();

    this.paused = false;
    if (roomEndpoint || !this.roomUpdater.endpoint) {
      this.roomUpdater.endpoint = roomEndpoint ? roomEndpoint : (this.apiBase + 'room');
    }
    if (personEndpoint || !this.personUpdater.endpoint) {
      this.personUpdater.endpoint = personEndpoint ? personEndpoint : (this.apiBase + 'incremental-people');
    }


    if (!this.miniviewport) {

      this.loadLayers();


      this.roomUpdater.firstRun().then(() => {
        this.personUpdater.roomsLoaded();
      });

      this.miniviewport = new MiniViewport(180, 180, {game: this});

      if (this.mode === 'table') {
        this.search = new Search(150, 150, {game: this});
      }

      this.hoverNameList = new HoverNameList(150, 200);
      this.hoverNameList.hide();
      this.hoverNameList.x = -1000;
      this.hoverNameList.y = -1000;

      this.toolTipText = new ToolTipText(180, 10);
      this.toolTipText.hide();
      this.toolTipText.x = 100;
      this.toolTipText.y = 100;

      this.resizeWindow();
      this.requestAnimationFrame();


      this.layers.overlays.push(this.miniviewport);
      if (this.search instanceof Search) {
        this.layers.overlays.push(this.search);
      }
      this.layers.overlays.push(this.hoverNameList);
      this.layers.overlays.push(this.toolTipText);
      return;
    }

    this.roomUpdater.resume();
    this.personUpdater.resume();


  }


  loadLayers()
  {

    this.layers = {

      ground : new Layer(document.getElementById('interactive-map-canvas-1')),
      people : new Layer(document.getElementById('interactive-map-canvas-2'), 'people'),
      overlays : new Layer(document.getElementById('interactive-map-canvas-3'))

    };

    this.layers.people.fullRedraw = true;

    this.setScale(this.scale);

    this.layers.overlays.fixed = true;
    // this.layers.people.hasZIndices = true;

    if (this.debugEnabled()) {
      this.fps = new Fps({fps: 0});
      this.fps.y = 70;
      this.layers.overlays.push(this.fps);
    }
    this.topBar = new TopBar(10, 70, this);
    this.layers.overlays.push(this.topBar);

    this.hoverMask = new HoverMask(this.layers.overlays, false);
  }


  animatePerson(person, path) {
    if(path === null){
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {

      if (this.focus) {

        person.isAnimating = true;

        let duration = Math.floor(person.speed * path.length / 17.5) / 15;

        person.gsap = gsap.to(person, {motionPath: {path: path.points, curviness: 0.175}, duration, ease: 'none', onUpdate: () => this.updateHoverMask(person) });

        person.gsap.then(() => {
          person.isAnimating = false;

          this.hoverMask.findInRegister('person-' + person.id).disable();

          resolve();
        });

        return;

      }

      let lastPoint = path.points[path.points.length - 1];
      person.x = lastPoint.x;
      person.y = lastPoint.y;
      resolve();

    });
  }

  updateHoverMask(person) {
    const position = {
      x: person.x - person.center.x,
      y: person.y - person.center.y,
    };

    const size = person.size * 1.5;

    this.hoverMask.add("person-" + person.id, position.x, position.y, size, size)
      .enable()
      .over(() => {
        person.gsap.pause();
        game.setToolTipText(person.x, person.y + (person.size / 2), person.getName(), false);
      })
      .out(() => {
        person.gsap.play();
        game.setToolTipText(null);
      })
      .click(() => {
        UrlExecutor.execute(person.data.url);
      });
  }

  resizeWindow() {

    this.x = 0;
    this.y = 0;

    if (this.miniviewport) {

      this.miniviewport.x = 20;
      this.miniviewport.y = this.getWindowSize().height - this.miniviewport.height - 20;
      this.miniviewport.needsPositioning = true;

    }

    if (this.search) {
      this.search.x = this.getWindowSize().width - this.search.width;
      this.search.y = this.getWindowSize().height - this.search.height;
      this.search.needsPositioning = true;
    }

    if (this.fps) {
      this.fps.y = this.getWindowSize().height - this.fps.height;
    }

    this.topBar.width = this.getWindowSize().width;


    let scales = [
      {
        minWidth : 0,
        scale : this.nativeScale
      },
      {
        minWidth : 2000,
        scale : 1
      }
    ];

    let scale = this.nativeScale;

    for (let i = 0 ; i < scales.length; i++) {
      if (this.getWindowSize().width > scales[i].minWidth) {
        scale = scales[i].scale;
      }
    }

    if (scale !== this.scale) {
      this.setScale(scale);
    }

    Object.keys(this.layers).forEach(layer => {

      this.layers[layer].x = 0;
      this.layers[layer].y = 0;
      this.layers[layer].resize(this.getWindowSize().width, this.getWindowSize().height, this.scale);

    });


  }

  requestAnimationFrame() {
    window.requestAnimationFrame(() => { this.renderThrottled(); });
  }

  renderThrottled() {

    if (this.paused) {
      return;
    }

    this.render(this.frame++);

    if (this.frame > 1000) {
      this.frame = 0;
    }

      this.requestAnimationFrame();
    return;
    if (!throttle) {
      return;
    }

    setTimeout(() => {
      this.requestAnimationFrame();
    }, 50);

  }


  render(frame) {

    if (this.paused) {
      return;
    }

    let screenWidth = this.getWindowSize().width;
    let screenHeight = this.getWindowSize().height;

    if (this.debugEnabled()) {
      this.fps.addFrame();
    }
    this.miniviewport.needsRendering = frame % 3 === 0;

    if (frame % 3 === 0){

      if (this.dx !== 0 || this.dy !== 0) {

        this.x += this.dx;
        this.y += this.dy;
        this.dx = 0;
        this.dy = 0;

      }

      // Clamp the movement of the screen. The middle of the screen cannnot leave the view
      let minX = this.scale * (0)
      let maxX = this.scale * (this.width - screenWidth);

      if(this.width < screenWidth) {
        minX = this.scale * (-(screenWidth - (this.width / 2)))
        maxX = this.scale * (this.width / 2);
      }
      if (this.x < minX) { this.x = minX;}
      if (this.x > maxX) { this.x = maxX;}


      let minY = this.scale * (0)
      let maxY = this.scale * (this.height - screenHeight);

      if(this.height < screenHeight) {
        minY = this.scale * (-(screenHeight - (this.height / 2)))
        maxY = this.scale * (this.height / 2);
      }
      if (this.y < minY) { this.y = minY;}
      if (this.y > maxY) { this.y = maxY;}

    }

    this.layers.ground.render(this.x, this.y, screenWidth, screenHeight,frame % 7 === 1);
    if (!throttle || frame % 2 === 1) {
      this.layers.people.render(this.x, this.y, screenWidth, screenHeight);
    }

    this.layers.overlays.render(0, 0, screenWidth, screenHeight);

    // this.layers.overlays.ctx.canvas.width = this.layers.overlays.ctx.canvas.width;
    // hoverMaskContainer.debug(this.layers.overlays.ctx);



  }

  setToolTipText(x, y, text, coordinatesAreFixed) {

    if (x === null) {

      this.toolTipText.hide();
      return;

    }

    this.toolTipText.setScale(this.scale);
    this.toolTipText.x = x - this.x / this.scale;
    this.toolTipText.y = y - this.y / this.scale;

    this.toolTipText.setText(text);
    this.toolTipText.show();

  }

  showHoverNameList(x, y, people) {

    if (x === null) {

      this.hoverNameList.hide();
      return;

    }


    this.hoverNameList.setScale(this.scale);
    this.hoverNameList.x = x - this.x / this.scale;
    this.hoverNameList.y = y - this.y / this.scale;
    this.hoverNameList.setPeople(people);
    this.hoverNameList.show();

  }

  positionRooms()
  {

    this.roomPositioner.position();

  }

  moveViewport(x, y) {


    if (!this.toolTipText.hidden) {
      this.toolTipText.hide();
    }

    if (!this.hoverNameList.hidden) {
      this.hoverNameList.addScroll(y);
      return false;
    }

    this.dx += x;
    this.dy += y;

  }

  mouseMove(x, y) {

    return hoverMaskContainer.mouseMove(x, y);

  }

  mouseClick(x, y) {

    return hoverMaskContainer.click(x, y);

  }

  mouseScroll(x, y, deltaY) {

    this.hoverNameList.addScroll(deltaY);
    this.hoverNameList.needsRendering = true;

  }

  mapCoordToScreenCoord(x, y) {

    x -= this.x / this.scale;
    y -= this.y / this.scale;

    return {x, y};

  }

  buildWall()
  {

    let distance = 75;

    let minX = null;
    let minY = null;
    let maxX = null;
    let maxY = null;

    this.rooms.forEach(room => {

      if (minX === null || room.x < minX) { minX = room.x; }
      if (maxX === null || room.x + room.width > maxX) { maxX = room.x + room.width; }

      if (minY === null || room.y < minY) { minY = room.y; }
      if (maxY === null || room.y + room.height > maxY) { maxY = room.y + room.height; }

    });



    this.wall = new Wall(maxX - minX + distance * 4, maxY - minY + distance * 4);

    this.wall.x = minX - distance * 2;
    this.wall.y = minY - distance * 2;

    this.layers.ground.push(this.wall);
  }

  getWindowSize() {
    return {
      width: window.innerWidth,
      height: window.innerHeight
    };
  }

}
